var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "wz_VcardChat",
      class: { bigChat: _vm.opened, smallChat: !_vm.opened },
      attrs: { id: "chat_" + _vm.dataWatchVisteur.visiteurID }
    },
    [
      _c(
        "drag",
        {
          staticClass: "drag",
          attrs: {
            "transfer-data": {
              visiteurID: _vm.dataWatchVisteur.visiteurID,
              placePupitreActif: _vm.dataWatchVisteur.placePupitre,
              menuStelected: _vm.dataWatchVisteur.menuSelected,
              reponseCobrowsing: _vm.dataWatchVisteur.reponseCobrowsing
            }
          },
          on: {
            dragstart: _vm.handleDragstart,
            dragend: _vm.handleDragend,
            dragenter: _vm.handleDragenter
          }
        },
        [
          _c(
            "v-toolbar",
            {
              class: {
                "grey lighten-2":
                  _vm.returnFocusSessionId == _vm.dataWatchVisteur.visiteurID &&
                  _vm.$store.state._User.connexionType == "freshdesk",
                accent:
                  _vm.returnFocusSessionId == _vm.dataWatchVisteur.visiteurID &&
                  _vm.$store.state._User.connexionType != "freshdesk",
                "grey lighten-4":
                  _vm.returnFocusSessionId != _vm.dataWatchVisteur.visiteurID,
                newMessageFocus:
                  _vm.returnFocusSessionId == _vm.dataWatchVisteur.visiteurID &&
                  _vm.checkLastMessage,
                newMessage:
                  _vm.returnFocusSessionId != _vm.dataWatchVisteur.visiteurID &&
                  _vm.checkLastMessage,
                toolbar_ChatBox: true
              },
              attrs: {
                dark:
                  _vm.returnFocusSessionId == _vm.dataWatchVisteur.visiteurID &&
                  _vm.$store.state._User.connexionType != "freshdesk",
                flat: "",
                dense: ""
              }
            },
            [
              _vm.visitorLeft == "yes" && !_vm.isMobile
                ? _c("div", { staticClass: "clientOffline error" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("offline")) + "\n        "
                    )
                  ])
                : _vm.visitorLeft == "maybe" && !_vm.isMobile
                ? _c("div", { staticClass: "clientOffline warning" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("changingPage")) +
                        "\n        "
                    )
                  ])
                : _vm.visitorLeft == "yes" && _vm.isMobile
                ? _c("div", { staticClass: "clientOffline error" })
                : _vm.visitorLeft == "maybe" && _vm.isMobile
                ? _c("div", { staticClass: "clientOffline warning" })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: { xs1: "", "ml-1": "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm.dataWatchVisteur.network == "facebook"
                    ? _c("wz-avatar", {
                        attrs: {
                          src: _vm.dataWatchVisteur.profile_pic,
                          username: _vm.nameVisiteur,
                          size: "38px"
                        }
                      })
                    : _vm.dataWatchVisteur.network == "whatsapp"
                    ? _c("wz-avatar", {
                        attrs: {
                          src: _vm.dataWatchVisteur.profile_pic,
                          username: _vm.nameVisiteur,
                          size: "38px"
                        }
                      })
                    : _vm.dataWatchVisteur.network == "moon"
                    ? _c("wz-avatar", {
                        attrs: {
                          username: "#" + _vm.nameVisiteur,
                          size: "35px"
                        }
                      })
                    : _c("wz-avatar", {
                        attrs: {
                          username: "#" + _vm.nameVisiteur,
                          size: "35px"
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { ellipsis: "", "ml-1": "" } },
                [
                  _c("v-toolbar-title", { staticClass: "ws_TitreChat" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.nameVisiteur) + "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-toolbar-title", { staticClass: "ws_sousTitreChat" }, [
                    _vm._v(_vm._s(_vm.lastMessage))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.$vuetify.breakpoint.xsOnly
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.afficheInfosVisiteur()
                        }
                      }
                    },
                    [_c("v-icon", { attrs: { large: "" } }, [_vm._v("info")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$vuetify.breakpoint.xsOnly
                ? _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.opened,
                          expression: "opened"
                        }
                      ],
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.toggleBigChat()
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "rotate90Icone" }, [
                        _vm._v(
                          _vm._s(_vm.fullWidth ? "unfold_less" : "unfold_more")
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$vuetify.breakpoint.xsOnly
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.toggleChat()
                        }
                      }
                    },
                    [
                      _c("v-icon", [
                        _vm._v(
                          _vm._s(
                            _vm.opened
                              ? "keyboard_arrow_down"
                              : "keyboard_arrow_up"
                          )
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function($event) {
                      return _vm.fermeChat()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.loadingChat
        ? _c(
            "v-container",
            { attrs: { "fill-height": "" } },
            [
              _c(
                "v-layout",
                {
                  attrs: { flex: "", "align-center": "", "justify-center": "" }
                },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("v-progress-circular", {
                            staticClass: "primary--text",
                            attrs: { indeterminate: "", size: 100, width: 1 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            chatSession: true,
            visioConfON: _vm.dataVisio.confURL || _vm.dataVisioVente.confName,
            visioConfOFF: !_vm.dataVisio.confURL && !_vm.dataVisioVente.confName
          },
          attrs: { id: "chatSession_" + _vm.datasVisiteur.visiteurID }
        },
        [
          _vm.dataVisio.confURL
            ? _c(
                "div",
                {
                  class: {
                    inactif: !_vm.dataVisio.confURL
                  },
                  attrs: { id: "watchBox_visioconf" }
                },
                [
                  _c("iframe", {
                    attrs: {
                      id: "apzExtension",
                      allow: "camera *;microphone *;self;display-capture",
                      src: _vm.dataVisio.confURL,
                      frameborder: "0"
                    },
                    on: {
                      error: _vm.handleVisioError,
                      load: _vm.handleVisioLoaded
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [{ name: "bar", rawName: "v-bar" }],
              class: {
                "WatchBox-contentChat": true,
                retract: !_vm.chatExpand,
                expand: _vm.chatExpand,
                fullWidthChat: _vm.fullWidth,
                vb: true
              },
              attrs: { id: _vm.id_conversation }
            },
            [
              _c(
                "div",
                {
                  ref: "contentChat",
                  staticClass: "WatchBox-conversation",
                  on: { scroll: _vm.handleScroll }
                },
                [
                  _vm._l(_vm.datasVisiteur.histoChat, function(
                    dataMessage,
                    index
                  ) {
                    return _c("v-hover", {
                      key: index,
                      class: {
                        bulle_BO:
                          !dataMessage.isTyping &&
                          !dataMessage.dateMessage &&
                          !dataMessage.marqueurMessageNonLu,
                        "bulle-message-non-lu_BO":
                          !dataMessage.isTyping &&
                          !dataMessage.dateMessage &&
                          dataMessage.marqueurMessageNonLu,
                        "bulle-date_BO": dataMessage.dateMessage,
                        green: dataMessage.type === "18"
                      },
                      style: "z-index:" + (dataMessage.indexMessage + 1) + ";",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var hover = ref.hover
                              return _c(
                                "div",
                                {},
                                [
                                  !dataMessage.isTyping &&
                                  !dataMessage.dateMessage &&
                                  !dataMessage.marqueurMessageNonLu
                                    ? _c(
                                        "div",
                                        {
                                          class:
                                            "bulle_" +
                                            dataMessage.auteur +
                                            "_BO"
                                        },
                                        [
                                          dataMessage.auteur == "Agent" ||
                                          dataMessage.auteur == "Bot"
                                            ? _c("wz-avatar", {
                                                staticClass: "avatarChatBo",
                                                attrs: {
                                                  username:
                                                    dataMessage.nameAuteur,
                                                  src:
                                                    _vm.domaine +
                                                    "/public/media/user/small/" +
                                                    dataMessage.agentId +
                                                    "_avatar.jpg",
                                                  size: "35px"
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          index > 1 &&
                                          _vm.datasVisiteur.histoChat[index - 1]
                                            .chatSession &&
                                          _vm.datasVisiteur.histoChat[index]
                                            .chatSession &&
                                          _vm.datasVisiteur.histoChat[index]
                                            .chatSession !=
                                            _vm.datasVisiteur.histoChat[
                                              index - 1
                                            ].chatSession
                                            ? _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "text-xs-center",
                                                      attrs: { xs12: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            label: "",
                                                            disabled: "",
                                                            color: "secondary",
                                                            "text-color":
                                                              "white"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "closing"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                right: "",
                                                                dark: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "offline_pin"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class:
                                                "message" +
                                                dataMessage.auteur +
                                                "_BO",
                                              on: {
                                                click: function($event) {
                                                  dataMessage.type == 18 &&
                                                    _vm.switchToScreenSharing()
                                                }
                                              }
                                            },
                                            [
                                              dataMessage.auteur ==
                                                "Visiteur" && _vm.isMobile
                                                ? _c(
                                                    "div",
                                                    {
                                                      class:
                                                        "nom_" +
                                                        dataMessage.auteur +
                                                        "_BO"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            dataMessage.type ==
                                                              2
                                                              ? "(" +
                                                                  _vm.$t(
                                                                    "msgAuto"
                                                                  ) +
                                                                  ")"
                                                              : ""
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      class:
                                                        "nom_" +
                                                        dataMessage.auteur +
                                                        "_BO"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.nameAuteur[
                                                              index
                                                            ]
                                                              ? dataMessage.nameAuteur
                                                              : dataMessage.visitorId ==
                                                                _vm
                                                                  .datasVisiteur
                                                                  .visiteurID
                                                              ? _vm.nameVisiteur
                                                              : dataMessage.visitorId
                                                          ) +
                                                          "\n                    " +
                                                          _vm._s(
                                                            dataMessage.type ==
                                                              2
                                                              ? "(" +
                                                                  _vm.$t(
                                                                    "msgAuto"
                                                                  ) +
                                                                  ")"
                                                              : ""
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  class:
                                                    "timestamp_" +
                                                    dataMessage.auteur +
                                                    "_BO",
                                                  attrs: {
                                                    "data-timestamp":
                                                      dataMessage.timestamp
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.dateHeure[index]
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              dataMessage.message &&
                                              dataMessage.message != "undefined"
                                                ? _c(
                                                    "div",
                                                    {
                                                      class:
                                                        "hms message_" +
                                                        dataMessage.auteur
                                                    },
                                                    [
                                                      _vm.findUrls[index].length
                                                        ? _c("div", {
                                                            staticClass:
                                                              "txtChat",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.findUrls[
                                                                  index
                                                                ]
                                                              )
                                                            }
                                                          })
                                                        : _c("div", {
                                                            staticClass:
                                                              "txtChat",
                                                            domProps: {
                                                              textContent: _vm._s(
                                                                dataMessage.message
                                                              )
                                                            }
                                                          })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.hasAttachment(
                                                dataMessage.attachments
                                              )
                                                ? _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticStyle: {
                                                          "text-decoration":
                                                            "none"
                                                        },
                                                        attrs: {
                                                          href: _vm.attachmentUrl(
                                                            dataMessage.attachments
                                                          ),
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm.isDocumentAttachment(
                                                          dataMessage.attachments
                                                        )
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "grey--text",
                                                                    attrs: {
                                                                      large: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "attachment\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.attachmentExtension(
                                                                      dataMessage.attachments
                                                                    )
                                                                  ) +
                                                                    "\n                      "
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _c("div", [
                                                              _vm.attachmentUrl(
                                                                dataMessage.attachments
                                                              )
                                                                ? _c("img", {
                                                                    staticClass:
                                                                      "attachmentsMedia",
                                                                    attrs: {
                                                                      src: _vm.attachmentUrl(
                                                                        dataMessage.attachments
                                                                      ),
                                                                      title: "",
                                                                      rel: "",
                                                                      alt: _vm.attachmentExtension(
                                                                        dataMessage.attachments
                                                                      )
                                                                    },
                                                                    on: {
                                                                      error:
                                                                        _vm.imageLoadError,
                                                                      load: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.remonteChat()
                                                                      }
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ])
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: hover,
                                                      expression: "hover"
                                                    }
                                                  ],
                                                  staticStyle: {
                                                    margin: "0",
                                                    position: "absolute",
                                                    top: "16px",
                                                    right: "6px"
                                                  },
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    title: _vm.$t("copyText")
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.copyMessage(
                                                        dataMessage.message
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [_vm._v("content_copy")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              dataMessage.status == "delivery"
                                                ? _c("div", {}, [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(
                                                          _vm.$t("messageSent")
                                                        ) +
                                                        ")"
                                                    )
                                                  ])
                                                : dataMessage.status == "read"
                                                ? _c("div", {}, [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(
                                                          _vm.$t("messageRead")
                                                        ) +
                                                        ")"
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : !dataMessage.isTyping &&
                                      !dataMessage.dateMessage &&
                                      dataMessage.marqueurMessageNonLu
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "alert-message-non-lu primary",
                                          attrs: { block: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.showUnreadMessages()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "message-non-lu WZ-MessageChat white--text"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    medium: "",
                                                    dark: ""
                                                  }
                                                },
                                                [_vm._v("forum")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$tc(
                                                      "unreadMessages",
                                                      _vm.nbMessageNonLu,
                                                      {
                                                        count:
                                                          _vm.nbMessageNonLu
                                                      }
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : !dataMessage.isTyping
                                    ? _c(
                                        "div",
                                        { staticClass: "bulle_date_BO" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dates-messages_BO WZ-MessageChat"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(dataMessage.timeStamp)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.dataWatchVisteur.histoChat, function(
                    dataMessage,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: dataMessage.timestamp
                          ? dataMessage.timestamp + "_" + index
                          : "message_" + index
                      },
                      [
                        dataMessage.isTyping
                          ? _c(
                              "div",
                              {
                                class: "isTyping_" + dataMessage.auteur + "_BO"
                              },
                              [
                                _c("div", { staticClass: "isTyping_nom_BO" }, [
                                  dataMessage.auteur == "Visiteur" &&
                                  _vm.isMobile
                                    ? _c("div", {
                                        staticClass: "wz_nom_visiteur"
                                      })
                                    : _c(
                                        "div",
                                        { staticClass: "wz_nom_visiteur" },
                                        [_vm._v(_vm._s(dataMessage.nameAuteur))]
                                      )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "isTyping_message" }, [
                                  _c(
                                    "div",
                                    { staticClass: "WatchBox-istyping_BO" },
                                    [
                                      _c("div", { staticClass: "bounce1" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "bounce2" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "bounce3" })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "txt-superIstyping" },
                                    [_vm._v(_vm._s(dataMessage.message))]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "slide-y-transition", mode: "in-out" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.filteredSentences.length &&
                            _vm.showFilteredSentences,
                          expression:
                            "filteredSentences.length && showFilteredSentences"
                        }
                      ],
                      staticStyle: { "z-index": "99", position: "relative" }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          directives: [{ name: "bar", rawName: "v-bar" }],
                          attrs: { height: "200" }
                        },
                        [
                          _c(
                            "v-list",
                            {
                              attrs: {
                                "two-line": "",
                                dense: "",
                                subheader: ""
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "" } },
                                    [
                                      _c("v-subheader", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$tc(
                                              "sentences",
                                              _vm.filteredSentences.length,
                                              {
                                                count:
                                                  _vm.filteredSentences.length
                                              }
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.showFilteredSentences = false
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "secondary" } },
                                        [_vm._v("close")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.filteredSentences, function(phrase) {
                                return _c(
                                  "v-list-tile",
                                  {
                                    key: phrase.id,
                                    on: {
                                      click: function($event) {
                                        _vm.status === "offline" &&
                                        _vm.$route.fullPath !==
                                          "/trafic/attente"
                                          ? ";"
                                          : _vm.$emit(
                                              "update:msg",
                                              phrase.title
                                            )
                                        _vm.showFilteredSentences = false
                                      }
                                    }
                                  },
                                  [
                                    _c("v-list-tile-content", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("truncate")(phrase.title, 80)
                                          ) +
                                          "\n                  "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "secondary--text",
                                              icon: "",
                                              small: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                _vm.status === "offline" &&
                                                _vm.$route.fullPath !==
                                                  "/trafic/attente"
                                                  ? ";"
                                                  : _vm.sendMessage({
                                                      message: phrase.title
                                                    })
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("send")])],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.$route.name != "monitoring" ||
              (_vm.$route.name === "monitoring" &&
                _vm.brideMenu("trafic_monitoring_chat_superviseur") === "1")
                ? _c(
                    "div",
                    { staticClass: "WatchBox-MessageWrapper" },
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "conteneur-WatchBox-MessageWrapper",
                          attrs: { "grid-list-xs": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { "flex-child": "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", "pa-0": "" } },
                                [
                                  _vm.datasVisiteur
                                    ? _c("v-textarea", {
                                        ref: "inputChat",
                                        attrs: {
                                          id: "tf_txtareaChat",
                                          loading: _vm.loading,
                                          rows: "2",
                                          "auto-grow": "",
                                          "full-width": "",
                                          "append-icon": "send",
                                          "hide-details": "",
                                          flat: "",
                                          box: "",
                                          placeholder: _vm.placeholder
                                        },
                                        on: {
                                          keyup: function(e) {
                                            return _vm.keyup(e)
                                          },
                                          keydown: function(e) {
                                            return _vm.keydown(e)
                                          },
                                          click: function($event) {
                                            return _vm.clickstartTimerExpand()
                                          },
                                          "click:append": function($event) {
                                            return _vm.clickSendMessage()
                                          }
                                        },
                                        model: {
                                          value: _vm.msgInput,
                                          callback: function($$v) {
                                            _vm.msgInput = $$v
                                          },
                                          expression: "msgInput"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              staticClass: "options-WatchBox-MessageWrapper",
                              attrs: { "flex-child": "", wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "WatchBox-Toolbar-Icone",
                                  attrs: {
                                    xs1: "",
                                    "mr-2": "",
                                    "text-xs-right": ""
                                  }
                                },
                                [
                                  _vm.datasVisiteur
                                    ? _c("wz-emoji-picker", {
                                        on: { addEmoji: _vm.addEmoji }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "WatchBox-Toolbar-Icone",
                                  attrs: {
                                    "mr-2": "",
                                    xs1: "",
                                    "text-xs-right": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "tf-icone-toolbar-chat",
                                                      attrs: {
                                                        flat: !_vm.dragEnter,
                                                        icon: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.addFileDropzone()
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("attachment")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3978246673
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("addPJ")))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.dragEnter &&
          (_vm.entLevel === "5" || _vm.entLevel === "6" || _vm.entLevel === "7")
            ? _c("vue-dropzone", {
                ref: "theDropZone",
                staticClass: "wz_dropzone actifDropZone",
                attrs: { id: "dropzone_BO", options: _vm.dropzoneOptions },
                on: {
                  "vdropzone-file-added": _vm.fileAdded,
                  "vdropzone-sending": _vm.sending,
                  "vdropzone-success": _vm.success,
                  "vdropzone-error": _vm.error,
                  "vdropzone-removed-file": _vm.removedFile,
                  "vdropzone-drop": _vm.vddrop,
                  "vdropzone-drag-start": _vm.vdstart,
                  "vdropzone-drag-end": _vm.vdend,
                  "vdropzone-drag-enter": _vm.vdenter,
                  "vdropzone-drag-over": _vm.vdover,
                  "vdropzone-drag-leave": _vm.vdleave
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeVisiovente
            ? _c(
                "div",
                {
                  staticClass: "tf_visioVente",
                  attrs: { div: _vm.nameDivVisioStreams }
                },
                [
                  _c(
                    "div",
                    { staticClass: "tf_menuVisio" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-chip",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "visioVente_num_visiteur",
                                          attrs: {
                                            color: "grey",
                                            "text-color": "white"
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-avatar",
                                          [
                                            _c(
                                              "v-icon",
                                              { staticClass: "primary" },
                                              [_vm._v("account_circle")]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.numContacts) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2530050986
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("Nombre d'intenautes connectés"))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "visioVente_stop",
                                          attrs: {
                                            fab: "",
                                            dark: "",
                                            small: "",
                                            color: "error"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.stopVisioVente()
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", { attrs: { dark: "" } }, [
                                          _vm._v("call_end")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            713127850
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Arrêter la Diffusion")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "visioVente_muteMic",
                                          attrs: {
                                            fab: "",
                                            dark: "",
                                            small: "",
                                            color: !_vm.muteMic
                                              ? "success"
                                              : "grey"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleMic()
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", { attrs: { dark: "" } }, [
                                          _vm._v("mic")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2684967290
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.textMuteMic))])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "visioVente_muteCam",
                                          attrs: {
                                            fab: "",
                                            dark: "",
                                            small: "",
                                            color: !_vm.muteCam
                                              ? "success"
                                              : "grey"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleCam()
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", { attrs: { dark: "" } }, [
                                          _vm._v("videocam")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2788378027
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.textMuteCam))])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "actionUnzoomVideo",
                    on: {
                      click: function($event) {
                        return _vm.toggleStream()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    class: {
                      tf_localVideo: true,
                      zoomStream: _vm.zoomStream
                    },
                    attrs: { id: _vm.nameDivLocalStream }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    class: {
                      tf_remoteVideo: true,
                      zoomStream: !_vm.zoomStream
                    },
                    attrs: { id: _vm.nameDivRemoteStream }
                  })
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("wz-dialog-close-chat", {
        attrs: {
          datasVisiteur: _vm.datasVisiteur,
          dialogCloseChat: _vm.dialogCloseChat
        },
        on: { fermeDialogCloseChat: _vm.fermeDialogCloseChat }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-349ffaba", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349ffaba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzFenetreChat.vue
// module id = null
// module chunks = 